var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',_vm._b({attrs:{"error":_vm.error}},'base-page',_vm.payload,false))}
var staticRenderFns = []

export { render, staticRenderFns }